import styled from 'styled-components/macro';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TableWrapper = styled.div`
  flex: 1;
  margin-bottom: 100px;
  table {
    thead {
      tr {
        th {
          padding: 5px 10px 10px 10px;
        }
      }
    }
  }
`;

export const Controls = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 10px 0;
`;
